<template>
  <div>
    <div class="card">
      <card card-body-classes="table-full-width px-3">
        <div slot="header">
          <h4 class="card-title f-20-mobile">Vendas por Horário do Período {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
        </div>

        <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
          <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
        </div>

        <bar-chart-reactive
          :chart-data="chartData" 
          :options="chartOptions"
          :height="200"
        ></bar-chart-reactive>

        <canvas id="canvasGradient"></canvas>
      </card>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { Card, BarChartReactive } from 'src/components'
import moment from 'moment'
import jQuery from 'jquery'
import {hexToRGB} from "@/components/Charts/utils";
import VendaService from '@/services/VendaService.js'

export default {
    components: {
      Card,
      BarChartReactive,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        chartData: {
        },
        chartOptions: {
          tooltips: {
            callbacks: {
              label: function(tooltipItems, data) { 
                // Percentage
                var dataset = data.datasets[tooltipItems.datasetIndex];

                var total = 0;
                for(let data of dataset.data) {
                  total += data;
                }

                var currentValue = dataset.data[tooltipItems.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1));

                return "R$ " + tooltipItems.yLabel.toFixed(2) + " (" + percentage + "%)";
              }
            }
          }
        },
        vendas: [],
      }
    },
    methods:{
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },
      loadVendas() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`;
        let loader = this.$loading.show()

        VendaService.loadChartHorarios(params).then(res => {
          this.vendas = res.data.table



          let fallBackColor = '#5c4ac7';
          let color = this.color || fallBackColor;

          const ctx = document.getElementById('canvasGradient').getContext('2d');
          const gradientFill = ctx.createLinearGradient(1, 270, 50, 100);
          gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
          gradientFill.addColorStop(1, hexToRGB(color, 0.6));


          this.chartData = {
            labels: res.data.labels,
            datasets: [{
              label: 'Horários',
              backgroundColor: gradientFill,
              borderColor: color,
              pointBorderColor: "#FFF",
              pointBackgroundColor: color,
              pointBorderWidth: 2,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 1,
              pointRadius: 4,
              fill: true,
              borderWidth: 1,

              data: res.data.data,
            },]
          }

          loader.hide()          
        }).catch(err => {
          loader.hide()          
          console.error(err)
        })
      }
    },
    mounted(){
      this.loadVendas()
    }
}
</script>